var $9700a8010c106d6b$exports = {};
$9700a8010c106d6b$exports = {
    "clear": `Vymaza\u{165}`,
    "invalid": `(neplatn\xe9)`,
    "loading": `Na\u{10D}\xedtava sa...`,
    "noResults": `\u{17D}iadne v\xfdsledky`
};


export {$9700a8010c106d6b$exports as default};
//# sourceMappingURL=sk-SK.module.js.map
